import React from "react";
import {FooterNavbar} from "./FooterNavbar/FooterNavbar";
import {FooterSignature} from "./FooterSignature/FooterSignature";
import {Container} from "react-bootstrap";
import footerBackground from "../../../assets/footer-bg-main.png";
import {FooterTopBackground} from "./FooterTopBackground/FooterTopBackground";
import {TextBlock} from "../../Blocks/TextBlock/TextBlock";
import videoGamesImg from "../../../assets/video_games.png";
import { MobileFooterMenu } from "./MobileFooterMenu/MobileFooterMenu";

export const MainFooter = () => {
    const content = `Witamy na Mojegry.pl – największym wirtualnym placu zabaw z bezpłatnymi grami online, przygotowanym specjalnie z myślą o dzieciach w każdym wieku! Nieważne ile masz lat, tutaj na pewno znajdziesz coś interesującego dla siebie.

Odkryj ponad 170 kategorii pełnych niesamowitych przygód, zabaw, kreatywnych wyzwań oraz edukacyjnych gier, dzięki którym nauka nowych umiejętności staje się prawdziwą przyjemnością. Chłopcy mogą przenieść się na wirtualne boisko oraz zasiąść za sterami niemal wszystkich istniejących pojazdów, a dziewczynki wcielą się w stylistki, zrobią modne zakupy lub stworzą piękne dekoracje do wymarzonego pokoju.

Specjalne miejsce mamy również dla najmłodszych – kolorowanki, puzzle oraz gry pełne ulubionych bohaterów z bajek czekają na odkrycie! Lubisz popularne gry logiczne takie jak kulki, trzy w linii czy Mahjong? Na Mojegry.pl znajdziesz ich najlepsze edycje!

Zapraszamy również do wspólnej zabawy z przyjaciółmi w grach dla dwóch, trzech, a nawet czterech osób. A najlepsze jest to, że nie musisz instalować żadnych dodatkowych aplikacji – wszystkie nasze gry odpalą się bez problemu w każdej przeglądarce na komputerze, smartfonie oraz tablecie.

Masz wolną chwilę? Odwiedź mojegry.pl i baw się dobrze z setkami darmowych gier online dostępnych na wyciągnięcie ręki!`;

    return (
        <>
            <FooterTopBackground class="footer-img" background={footerBackground} />
            <Container fluid className="main-footer" style={{backgroundColor: "#4090FF"}}>
                <TextBlock title={"Gry dla dzieci online"} content={content} image={videoGamesImg}/>
                <FooterNavbar/>
                <FooterSignature/>
                <MobileFooterMenu/>
            </Container>
        </>
    );
}